module.exports = __webpack_public_path__ + "static/media/headersectionmobile.7c982e3d.png";